export const ModalEventbus = Symbol('[modal]: modal event bus');
export const ModalConfirmEvent = Symbol('[modal]: confirm');
export const ModalOkEvent = Symbol('[modal]: ok');
